import { LogLevel, MarketSource } from "./types";

export const ALL_AFFILIATION = "전체";

export const MARKET_MAX_REFERENCE_PRODUCTS = 10;
// Up to 10 products x 5 market sources
export const MARKET_MAX_NETWORK_CALLS = 50;
export const MARKET_FETCH_DELAY_MS = 900;
export const MARKET_RETRY_COUNT = 2;
export const MARKET_RETRY_BASE_DELAY_MS = 1200;
export const MARKET_RATE_LIMIT_COOLDOWN_MS = 5 * 60 * 1000;
export const MARKET_CACHE_TTL_MS = 24 * 60 * 60 * 1000;
export const MARKET_CACHE_KEY = "ai_curation_external_reference_cache_v1";
export const MARKET_RATE_LIMIT_KEY_PREFIX = "ai_curation_rate_limit_until";

export const CURATION_MIN_ITEMS = 12;
export const CURATION_MAX_ITEMS = 48;

export const RUNNING_FRAMES = ["|", "/", "-", "\\"];

export const MARKET_SOURCE_CONFIG: Record<
  MarketSource,
  { label: string; searchUrlPrefix: string; proxyPrefix: string }
> = {
  coupang: {
    label: "쿠팡",
    searchUrlPrefix: "https://www.coupang.com/np/search?q=",
    proxyPrefix: "https://r.jina.ai/http://www.coupang.com/np/search?q=",
  },
  naver_store: {
    label: "네이버스토어",
    searchUrlPrefix: "https://search.shopping.naver.com/search/all?query=",
    proxyPrefix:
      "https://r.jina.ai/http://search.shopping.naver.com/search/all?query=",
  },
  kurly: {
    label: "마켓컬리",
    searchUrlPrefix: "https://www.kurly.com/search?sword=",
    proxyPrefix: "https://r.jina.ai/http://www.kurly.com/search?sword=",
  },
  "11st": {
    label: "11번가",
    searchUrlPrefix: "https://search.11st.co.kr/Search.tmall?kwd=",
    proxyPrefix: "https://r.jina.ai/http://search.11st.co.kr/Search.tmall?kwd=",
  },
  gmarket: {
    label: "G마켓",
    searchUrlPrefix: "https://browse.gmarket.co.kr/search?keyword=",
    proxyPrefix:
      "https://r.jina.ai/http://browse.gmarket.co.kr/search?keyword=",
  },
};

export const MARKET_SOURCE_ORDER: MarketSource[] = [
  "coupang",
  "naver_store",
  "kurly",
  "11st",
  "gmarket",
];

export const LOG_LEVEL_TEXT: Record<LogLevel, string> = {
  info: "INFO",
  success: "DONE",
  warn: "WARN",
  error: "ERROR",
};
